import * as React from 'react';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import './PolicyDetails.css';
import { DASHBOARD, PERSONAL_INSURANCE, FNOL_SUBMIT_CLAIM } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon, showCancelPolicyEdit, showBankingDetails, showReplacementValueCallMeModal, showUpdatePolicyModal, showNoLongerMainline } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { setPortableItemDetails, setIsInEdit, setSelectedPortableDetail, updatePortableRiskItemToQuote, getPortableRiskItemDetailedInfo, checkReplacementValue, addProduct, setReplacementValue, setStartReplacementValue } from '../../../actions/salesActions';
import ReplacementValueCheck from './ReplacementValueCheck/ReplacementValueCheck';
import { PRODUCT_PORTABLE_POSSESSIONS, SET_CUSTOMER_DATA } from '../../../constants/constants';
import { AMEND_POLICY_PORTABLE } from '../../../constants/products';
import PolicyDetailsCellphone from './PolicyDetailsCellphone';
import { setPolicyReducer } from '../../../actions/profileActions';
import { NAM_COUNTRY_ID } from '../../../constants/internationalization';
import FAQItem from '../../FAQ/FAQItem';

const PolicyDetailsPortables = () => {
    const profileState = useSelector(state => state.profile);
    const salesState = useSelector(state => state.sales);
    const cartState = useSelector(state => state.cart);
    let cover = useSelector(state => state.profile.selectedPersonalCover)
    const dispatch = useDispatch();
    const [isInEdit] = useState(false);
    const [accordionFAQActiveKey, setAccordionFAQActiveKey] = useState(-1);

    function showCancelEdit() {
        dispatch(showCancelPolicyEdit());
    }

    function addAnItem() {
        if (profileState.countryId === 157) {
            dispatch(showComingSoon());
        }
        else {
            var hasCar = false;
            if (cartState.products) {
                hasCar = cartState.products?.filter(x => (x.name.toLowerCase() === 'car' || x.name.toLowerCase() === 'motorbike' || x.name.toLowerCase() === 'building' || x.name.toLowerCase() === 'home contents' || x.name.toLowerCase().includes('chilli') /*|| x.name.toLowerCase().includes('bling')*/)).length > 0
            }
            var hasPolicyMainline = false;
            if (profileState.personalPolicies[0] !== undefined) {
                if (profileState.personalPolicies[0].covers.length > 0) {
                    hasPolicyMainline = profileState.personalPolicies[0].covers.filter(x => hasPolicyMainline = profileState.personalPolicies[0].covers.filter(x => (x.productName.toLowerCase() === 'car' || x.productName.toLowerCase() === 'motorbike' || x.productName.toLowerCase() === 'building' || x.productName.toLowerCase() === 'home contents' || x.productName.toLowerCase().includes('chilli'))).length > 0).length > 0
                }
            }
            if (!hasCar && !hasPolicyMainline) {
                dispatch(showNoLongerMainline());
            }
            else {
                dispatch(addProduct(PRODUCT_PORTABLE_POSSESSIONS));
            }
        }
    }

    async function setSelectedPortable() {
        dispatch(setPolicyReducer(SET_CUSTOMER_DATA, 'selectedPortablePossession', ""))
    }

    async function editPolicyInfo(item) {
        if (profileState.countryId === 157) {
            dispatch(showComingSoon());
        }
        else {
            setSelectedPortable();
            var filterItem = cover.riskItems[0].portablePossessions.filter(x => x.id === item.id)[0];
            filterItem.totalPolicyPremium = profileState.selectedPersonalPolicy.totalPolicyPremium;
            await dispatch(showUpdatePolicyModal(AMEND_POLICY_PORTABLE, filterItem));
        }
    }

    function cancelEdit() {
        dispatch(showCancelPolicyEdit());
        dispatch(setIsInEdit(false));
    }

    function saveEdit() {
        dispatch(showBankingDetails());
    }

    async function submitAClaim(cover : any) {
        if (profileState.countryId === 157) {
            dispatch(showComingSoon());
        }
        else {
            let riskItemSelectable = { id: cover.id, productName: "Portable possessions", riskItems: [cover] }
            await dispatch(resetFNOL());
            await dispatch(clearSelectedDamages());
            await dispatch(setCoverFromPersonalInsurance(riskItemSelectable));
            await dispatch(setStep(1, 1));
            await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
        }
    }

    async function updateRiskItemToQuote(e: any) {
        var totalReplacementValue = 0;
        for (var i = 0; i < profileState.selectedPersonalCover.riskItems[0].portablePossessions.length; i++) {
            if (salesState.selectedPortableDetail.id === profileState.selectedPersonalCover.riskItems[0].portablePossessions[i].id) {
                totalReplacementValue += salesState.replacementValue
            }
            else {
                totalReplacementValue += parseFloat(profileState.selectedPersonalCover.riskItems[0].portablePossessions[i].insuredForValue)
            }
        }
        if (totalReplacementValue > 300000) {
            dispatch(setIsInEdit(false));
            dispatch(showReplacementValueCallMeModal())
        }
        else {
            dispatch(updatePortableRiskItemToQuote());
        }
    }

    async function setItemDetails(policyRiskItemId: any) {
        dispatch(setPortableItemDetails(policyRiskItemId));
    }

    async function setSelectedDetail(filterItem: any) {
        dispatch(setSelectedPortableDetail(filterItem));
    }

    async function checkPortableReplacementValue() {
        dispatch(checkReplacementValue());
    }

    async function getRiskItemDetailedInfo(id: any, riskItemType: any) {
        dispatch(getPortableRiskItemDetailedInfo(id, riskItemType));

    }

    function getDropdownItems(item: any) {
        let faqSet = [{
            header: "Insurance history",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">No. of claims in the last 2 years</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + item.numberOfClaims + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + item.lastStolenClaim + '</p>' +
                '</div>',
            id: 1
        },];

        let faq;
        if (faqSet) {
            faq = faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={accordionFAQActiveKey} />
                }
            });
        }
        return faq;
    }

    let portables = <div></div>;
    let portablesMobile = <div></div>;
    let selectedItem = <div></div>;

    if (salesState.selectedPortableDetail && salesState.selectedPortableDetail.id && profileState.selectedPortablePossession == "") {
        selectedItem = <ReplacementValueCheck
            id={salesState.selectedPortableDetail.id}
            description={salesState.selectedPortableDetail.description}
            subDescription={salesState.selectedPortableDetail.subDescription}
            premium={salesState.selectedPortableDetail.premium}
            totalPolicyPremium={salesState.selectedPortableDetail.totalPolicyPremium}
            updateRiskItemToQuote={(e) => updateRiskItemToQuote(e)}
            setItemDetails={(e) => setItemDetails(e)}
            setSelectedDetail={(e) => setSelectedDetail(e)}
            profileState={profileState}
            salesState={salesState}
            checkReplacementValue={() => checkPortableReplacementValue()}
            getRiskItemDetailedInfo={(id, riskItemType) => getRiskItemDetailedInfo(id, riskItemType)}
            setIsInEdit={(e) => dispatch(setIsInEdit(e))}
            setReplacementValue={(e) => dispatch(setReplacementValue(e))}
            setStartReplacementValue={(e) => dispatch(setStartReplacementValue(e))}
        />
    }
    else if (profileState.selectedPortablePossession != "") {
        selectedItem = <PolicyDetailsCellphone CellphoneCover={profileState.selectedPortablePossession} />
    }

    if (cover !== undefined) {
        portables = cover.riskItems[0].portablePossessions.map((item) => {
            let coverStartDate = (item.coverStartDate?.toString().trim().length > 0) ? item.coverStartDate : "";

            if (item.isCellphone) {
                return <PolicyDetailsCellphone CellphoneCover={item}/>
            }
            else {
                let faq = getDropdownItems(item);

                return <div key={item.id} id={item.id} className="box col-12 mt-2 mb-2">

                    <div id="PolicyDetails">
                        <div className="row mb-lg-0 pt-lg-3">
                            <div className="col-8">
                                <h2 className="carName mb-0">{item.description}</h2>
                            </div>
                            <div className="col-4 text-right">
                                {!isInEdit &&
                                    <button className="btn btn-outline-red mb-3" onClick={() => editPolicyInfo(item)} id="EditPolicy">Update policy</button>
                                }
                            </div>
                        </div>
                        <div className="row border-bottom mb-3">
                            <div className="col-8">
                                <h3 className="coverAmount mb-3">{profileState.currencySymbol}{item.premium}pm</h3>
                                {coverStartDate.length > 0 &&
                                    <div className="mb-3">
                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                    </div>
                                }
                            </div>
                            <div className="col-4 text-right mb-3">
                                <button className="btn btn-solid-aqua" onClick={() => submitAClaim(item)}>Submit a claim</button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <p className="mb-1"><b>Excess amount</b></p>
                                {item.excess === "15.00" &&
                                <p className="excessAmount">15% of claim value (min " + profileState.currencySymbol + "1250.00)"</p> ||
                                <p className="excessAmount">{profileState.currencySymbol + item.excess}</p>
                                }
                                <p className="Insured-for">Insured for {profileState.currencySymbol}{item.insuredForValue}</p>
                            </div>
                        </div>
                    </div>

                    <div id="DetailsDiv" className="pb-lg-4">
                        <Card className="policyDetailsCodeRed ">
                            <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                                <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                    {faq}
                                </Accordion>
                            </div>
                        </Card>
                    </div>
                </div>
            }
        });

        portablesMobile = cover.riskItems[0].portablePossessions.map((item) => {
            let coverStartDate = (item.coverStartDate?.toString().trim().length > 0) ? item.coverStartDate : "";

            if (item.isCellphone) {
                return <PolicyDetailsCellphone CellphoneCover={item} />
            }
            else {
                let faq = getDropdownItems(item);

                return <div key={item.id} id={item.id} className="box mt-2 mb-2 pb-3 pl-3 pr-3">
                <div id="PolicyDetails">
                    <div className="row mb-lg-0 pt-3">
                        <div className="col-12">
                            <h2 className="carName mb-0">{item.description}</h2>
                        </div>
                    </div>
                    <div className="row border-bottom mb-3">
                        <div className="col-12">
                            <h3 className="coverAmount mb-3">{profileState.currencySymbol}{item.premium}pm</h3>
                                {coverStartDate.length > 0 &&
                                    <div className="mb-3">
                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                    </div>
                                }
                        </div>
                        <div className="col-12 text-right">
                            {!salesState.isInEdit &&
                                <button className="btn btn-outline-red mb-3" onClick={() => editPolicyInfo(item)} id="EditPolicy">Update policy</button>
                            }
                            {salesState.isInEdit &&
                                <div className="col-12">
                                    <div className="mt-3 mb-3">
                                        <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                        <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-12 text-right mb-3">
                            <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p className="mb-1"><b>Excess amount</b></p>
                                <p className="excessAmount">{"5% of claim value (min " + profileState.currencySymbol + "1250.00)"}</p>
                            <p className="Insured-for">Insured for {profileState.currencySymbol}{item.insuredForValue}</p>
                        </div>
                    </div>
                </div>

                <div id="DetailsDiv" className="pb-lg-4">
                    <Card className="policyDetailsCodeRed ">
                        <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                            <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                {faq}
                            </Accordion>
                        </div>
                    </Card>
                </div>
            </div>
            }
        });
    }

    //const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }];

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Portable possessions" />
            }

            {salesState.isInEdit && profileState.selectedPortablePossession == "" &&
                <div id="Update-policy" className="card col-12 mb-3">
                    <div className="card-body text-centerThat decrease monthly">

                        <h3>Update your policy</h3>
                        <p>Here you can edit your replacement value.</p>

                        <p>Hit <b>'Save'</b> to apply your changes, or <b>'Cancel'</b> to undo them.</p>
                        <p><b>Please note:</b> You'll need to confirm your banking details and accept our legal terms to finish updating your policy.</p>

                        <div className="row mt-3 mb-3 update-policy-button-holder">
                            <div className="col-12 col-lg-6 order-lg-1">
                                <button className="btn btn-outline-white mt-lg-0 mb-2 mt-2 float-lg-right" onClick={saveEdit} id='SavePolicyUpdate'>Save</button>
                            </div>

                            <div className="col-12 col-lg-6 order-lg-2 mt-3 mt-lg-0">
                                <button className="btn btn-outline-white mr-lg-0 mb-2 float-lg-left" onClick={showCancelEdit} id='CancelPolicyUpdate'>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            }


            {!salesState.isInEdit &&
                <div>
                    <div className="box mb-3">
                        <div className="pt-3 mb-lg-0 col-lg-12">
                            <div className="d-lg-block d-none">
                                <div className="row mb-lg-0">
                                    <div className="col-8">
                                        <h2 className="carName mb-0">Portable possessions</h2>
                                    </div>
                                    <div className="col-4 text-right">
                                    {profileState.countryId === NAM_COUNTRY_ID && <button className="btn btn-solid-green mb-3" onClick={addAnItem} id="AddAnItem">Add an item</button>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-8">
                                        <p className="mb-2">Total amount</p>
                                        <p className="coverAmount">{profileState.currencySymbol}{cover.riskItems[0].premium} pm</p>
                                    </div>
                                </div>
                            </div>
                            <div className="d-lg-none d-block" >
                                <div className="row mb-lg-0">
                                    <div className="col-12">
                                        <h2 className="carName mb-0">Portable possessions</h2>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-8">
                                        <p className="mb-2">Total amount</p>
                                        <p className="coverAmount">{profileState.currencySymbol}{cover.riskItems[0].premium} pm</p>
                                    </div>
                                </div>
                                <div id="PolicyDetailsMobile">
                                    <button className="btn btn-solid-green mb-3" onClick={addAnItem} id="AddAnItem">Add an item</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }

            <div className="mb-2">
                <div className="d-lg-block d-none" >
                    {salesState.isInEdit ? selectedItem : portables}
                </div>
            </div>

            <div className="d-lg-none d-block mb-5" id="PolicyDetailsMobile" style={{ display: "none" }}>
                {salesState.isInEdit ? selectedItem : portablesMobile}
            </div>
            {!salesState.isInEdit && profileState.countryId !== NAM_COUNTRY_ID &&
                <Card className="mt-3 mb-5 cursor-pointer">
                    <Card.Body>
                    <div className="row noma" onClick={addAnItem}>
                        <div className="nopa mr-20px">
                            <div className="portable-possessions add-cover-image" />    
                            </div>
                            <div className="col-lg col-9 nopa">
                                <div className="row noma">
                                <div className={"col-11 px-0 nopa" + (isMobile ? " mt-2" : " mt-3")}>
                                    <p className="mb-0"><b>Insure more portable possessions</b></p>
                                    </div>
                                <div className={"col-lg col-1 pl-0 pl-lg-2 nopa" + (isMobile ? " mt-2" : " mt-3")} style={{ paddingTop: "2px" }}>
                                    <img src="./Images/TopNav/add-cover-nugreen-46px-46px.svg" className="mx-auto d-block cursor-pointer" onClick={addAnItem} style={{ height: "30px" }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            }
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetailsPortables);